module.exports = __webpack_public_path__ + "img/image_middle_condition_d@2x.6c2456d3.png";